import {intlShape} from '@wallaby-ui/core';
import {isEmpty as _isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl';

import GridFilterLabel from './GridFilterLabel';
import GridFilterRemoveButton from './GridFilterRemoveButton';
import GridFilterSubmitButton from './GridFilterSubmitButton';
import styles from './GridFilterWrapper.less';

const I18N = defineMessages({
  SELECTED_FILTER: {
    id: 'filter.selectedFilter.text',
    defaultMessage: 'Selected filter',
    description: 'label for selected filter in grid filter component',
  },
});

class GridFilterWrapper extends React.PureComponent {
  render() {
    const {
      children,
      filter,
      isActive,
      isEmpty,
      label,
      loadedModel,
      removeFilter,
      showValue,
      submitFilter,
      intl,
    } = this.props;

    return (
      <div className={styles.dlGridFilterWrapper}>
        <div className={styles.dlGridFilterWrapperFirstRow}>
          <GridFilterLabel label={label} />
          <GridFilterRemoveButton
            removeFilter={removeFilter}
            isVisible={isActive}
            item={filter}
          />
        </div>
        {children(intl)}
        {!_isEmpty(loadedModel) && showValue ? (
          <div className={styles.dlGridFilterWrapperSelectedValueWrapper}>
            <span className={styles.dlGridFilterWrapperSelectedValueLabel}>
              <FormattedMessage {...I18N.SELECTED_FILTER} />
              {':'}
            </span>
            <span
              className={styles.dlGridFilterWrapperSelectedValue}
              title={loadedModel.toComponentString(null, intl)}
            >
              {loadedModel.toComponentString(null, intl)}
            </span>
          </div>
        ) : null}
        <GridFilterSubmitButton
          handleClick={submitFilter}
          isDisabled={isEmpty}
          tabIndex={0}
        />
      </div>
    );
  }
}

GridFilterWrapper.displayName = 'GridFilterWrapper';

GridFilterWrapper.propTypes = {
  intl: intlShape.isRequired,
  filter: PropTypes.objectOf(PropTypes.any).isRequired,
  removeFilter: PropTypes.func.isRequired,
  submitFilter: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  isEmpty: PropTypes.bool,
  label: PropTypes.string,
  loadedModel: PropTypes.objectOf(PropTypes.any),
  showValue: PropTypes.bool,
};

GridFilterWrapper.defaultProps = {
  isActive: false,
  isEmpty: true,
  label: undefined,
  loadedModel: undefined,
  showValue: true,
};

export default injectIntl(GridFilterWrapper);
